module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/compreoalquile.15296d10.svg";